import { render, staticRenderFns } from "./UpdateMyinfo.vue?vue&type=template&id=05d9fd5e&scoped=true&"
import script from "./UpdateMyinfo.vue?vue&type=script&lang=js&"
export * from "./UpdateMyinfo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMyinfo.vue?vue&type=style&index=0&id=05d9fd5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d9fd5e",
  null
  
)

export default component.exports